import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { WorkOrderChangeObjectSelectionItem } from 'gql/graphql';
import type {
    IUseGetIncludedCountDataProps,
    IUseGetIncludedCountDataResult,
} from 'pages/Project/Common/WorkOrderStructure/types';

import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { uerWorkOrderChangeObjectSelectionListIsIncludedGql } from '../../WorkOrderChangeQueries';

const requestId = 'uerWorkOrderChangeObjectSelectionListIsIncluded';

export const useUerWorkOrderChangeGetIncludedCountData = (
    props: IUseGetIncludedCountDataProps,
): IUseGetIncludedCountDataResult<WorkOrderChangeObjectSelectionItem> => {
    const dispatch = useDispatch();
    const { workOrderOrChangeId } = props;

    const [
        uerWorkOrderChangeObjectSelectionListIsIncludedData,
        uerWorkOrderChangeObjectSelectionListIsIncludedStatus,
        ,
        uerWorkOrderChangeObjectSelectionListIsIncludedRequest,
    ] = useRequest({
        requestId,
        query: uerWorkOrderChangeObjectSelectionListIsIncludedGql,
        withEffect: false,
    });

    const [uerWorkOrderChangeObjectSelectionListIsIncludedReset] = useResetStoreData({ requestId });

    const reset = useCallback(
        () => uerWorkOrderChangeObjectSelectionListIsIncludedReset(undefined),
        [uerWorkOrderChangeObjectSelectionListIsIncludedReset],
    );

    const makeRequest = useCallback(
        (constructionTypeId?: number) => {
            const where = constructionTypeId
                ? {
                      constructionType: { id: { eq: constructionTypeId } },
                  }
                : undefined;

            dispatch(
                uerWorkOrderChangeObjectSelectionListIsIncludedRequest({
                    workOrderChangeId: workOrderOrChangeId,
                    where,
                }),
            );
        },
        [dispatch, uerWorkOrderChangeObjectSelectionListIsIncludedRequest, workOrderOrChangeId],
    );

    const items = useMemo(
        () =>
            (uerWorkOrderChangeObjectSelectionListIsIncludedData?.uerWorkOrderChangeObjectSelectionList?.items ||
                []) as WorkOrderChangeObjectSelectionItem[],
        [uerWorkOrderChangeObjectSelectionListIsIncludedData?.uerWorkOrderChangeObjectSelectionList?.items],
    );

    return {
        constructionTypeIdGetMap: ['constructionType', 'id'],
        includedFlagGetMap: ['isIncluded'],
        items,
        makeRequest,
        reset,
        status: uerWorkOrderChangeObjectSelectionListIsIncludedStatus,
    };
};
